// extracted by mini-css-extract-plugin
module.exports = {"formClass":"UpdateOrderAddress_formClass__1618R","flexBox":"UpdateOrderAddress_flexBox__ffm3Y","inputBox":"UpdateOrderAddress_inputBox__2Lv_C"};